export enum SupportFormKind {
  Default,
  Extended,
  Bot,
}
